import React from 'react';
import { ui } from '../../styles/shared';

interface ErrorBannerProps {
    message: string;
    onDismiss: () => void;
}

/** Röd felruta med stängknapp. Samma utseende på alla sidor (ui.errorBox). */
const ErrorBanner: React.FC<ErrorBannerProps> = ({ message, onDismiss }) => (
    <div style={{ ...ui.errorBox, alignItems: 'center' }} role="alert">
        <div><strong>Fel:</strong> {message}</div>
        <button
            onClick={onDismiss}
            aria-label="Stäng"
            style={{ backgroundColor: 'transparent', border: 'none', color: '#721c24', fontSize: '20px', cursor: 'pointer', padding: '0 5px' }}
        >
            ×
        </button>
    </div>
);

export default ErrorBanner;
